// Gentle ambient backdrop for dark pages: soft color auroras + faint starfield.
export const AmbientBackground = () => (
  <div aria-hidden className="pointer-events-none fixed inset-0 -z-10 overflow-hidden bg-qbbg">
    {/* faint starfield */}
    <div
      className="absolute inset-0 opacity-[0.35]"
      style={{
        backgroundImage:
          "radial-gradient(rgba(255,255,255,0.9) 0.6px, transparent 0.7px), radial-gradient(rgba(255,255,255,0.5) 0.5px, transparent 0.6px)",
        backgroundSize: "120px 120px, 70px 70px",
        backgroundPosition: "0 0, 35px 45px",
      }}
    />
    {/* soft auroras — jewel tones from the logo watercolor (hidden on mobile for performance) */}
    <div className="hidden sm:block absolute -top-48 left-[15%] w-[620px] h-[620px] rounded-full blur-[150px]" style={{ background: "rgba(47,179,160,0.08)" }} />
    <div className="hidden sm:block absolute top-1/2 -left-40 w-[560px] h-[560px] rounded-full blur-[160px]" style={{ background: "rgba(123,94,167,0.08)" }} />
    <div className="hidden sm:block absolute bottom-[-10%] right-[10%] w-[640px] h-[640px] rounded-full blur-[170px]" style={{ background: "rgba(181,98,58,0.07)" }} />
  </div>
);
